import React from 'react';
import { StyledEntryStatus } from './style';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions, ChartData } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

// 가운데 텍스트 플러그인

interface IProps {
  test?: string;
}

export const EntryStatus: React.FC<IProps> = ({ test }) => {
  const formatNumber = (value: number) => value.toLocaleString('ko-KR');

  const color = [
    '#1E3A8A',
    '#2563EB',
    '#38BDF8',
    '#A855F7',
    '#E5E7EB',
    '#E5E7EB',
    '#E5E7EB',
    '#E5E7EB',
    '#E5E7EB'
  ];

  const rowData = [
    { label: 'Samsung', value1: 530, value2: 10 },
    { label: 'AIC', value1: 12, value2: 8 },
    { label: 'ALFA', value1: 15, value2: 15 },
    { label: 'GSiL', value1: 15, value2: 10 },
    { label: 'BLDA', value1: 15, value2: 10 }
  ];

  const data: ChartData<'doughnut'> = {
    // 예시 값 (섹터별 값)
    labels: rowData.map((item) => item.label),
    datasets: [
      {
        data: rowData.map((item) => item.value2),
        backgroundColor: color,
        borderWidth: 0,
        borderRadius: 2, // 각 조각 둥글게
        spacing: 2 // 조각 사이 여유
      }
    ]
  };

  const summeryData = {
    total: 1800,
    workers: 1500
  };

  const centerTextPlugin = {
    id: 'centerTextPlugin',
    afterDraw: (chart: any) => {
      const { ctx, width, height } = chart;

      ctx.save();
      const totalText = `${formatNumber(summeryData.total)} / ${formatNumber(summeryData.workers)}`; /*'1,830 / 1,500'*/
      const subText = 'Workers';

      ctx.font = '600 11px sans-serif';
      ctx.fillStyle = '#2F2F35';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(totalText, width / 2, height / 2 - 6);

      ctx.font = '600 11px sans-serif';
      ctx.fillStyle = '#2F2F35';
      ctx.fillText(subText, width / 2, height / 2 + 12);

      ctx.restore();
    }
  };

  ChartJS.register(centerTextPlugin);

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    cutout: '60%', // 안쪽 구멍 크기 (도넛 두께)
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true
      }
    }
  };
  return (
    <StyledEntryStatus>
      <div className={'component-title'}>Entry Status{test}</div>
      <div className={'component-body'}>
        <div className={'chart'}>
          <Doughnut data={data} options={options} />
        </div>
        <div className={'item-list'}>
          {rowData.map((item, index: number) => (
            <div className={'item'} key={index}>
              <div className={'label'}>
                <div className={'label-icon'} style={{ backgroundColor: color[index] }}></div>
                <div className={'label-text'}>{item.label}</div>
              </div>
              <div className={'value'}>{`${item.value1} / ${item.value2}`}</div>
            </div>
          ))}
        </div>
      </div>
    </StyledEntryStatus>
  );
};
